/**
 * winデータコンバーター
 * 2022/07/28 各センサーXYZごとに計算していたのを関数化してまとめる(村田)
 * 2023/01/18 配列化し4つ以上のセンサー対応(村田)
 * 注意！）デコードオブジェクトを配列化したため過去のものと互換性がない
 */
var SHIFT_GAL = 1000000;

/**
 * winデータ⇒加速度配列に直す
 */
export function decodeWinData(win, sampling) {
  var winObj = {};  // 返り値（winオブジェクト）
  var obj = { hexIndex: 0 };
  obj.hexIndex += 4;
  var winyy = byte2Hex(win[obj.hexIndex++]);
  var winMM = byte2Hex(win[obj.hexIndex++]);
  var windd = byte2Hex(win[obj.hexIndex++]);
  var winhh = byte2Hex(win[obj.hexIndex++]);
  var winmm = byte2Hex(win[obj.hexIndex++]);
  var winss = byte2Hex(win[obj.hexIndex++]);
  var winlng = parseInt(byte2Hex(win[0]) + byte2Hex(win[1]) + byte2Hex(win[2]) + byte2Hex(win[3]), 16);
  // 頭の時刻
  //ロガーがGMT+9(JST)でタイムゾーンが違う場合
  //winObj.time = new Date(Date.UTC("20"+winyy, winMM-1, windd, winhh, winmm, winss)).getTime() - 1000 * 60 * 60 * 9;
  //ロガーとブラウザのタイムゾーンが同じ場合
  var winDateStr = "20" + winyy + "/" + winMM + "/" + windd + " " + winhh + ":" + winmm + ":" + winss;
  winObj.time = new Date(winDateStr).getTime();
  winObj.ch = new Array(1);
  winObj.accX = new Array(100);
  winObj.accY = new Array(100);
  winObj.accZ = new Array(100);
  for (let i=0; winlng > obj.hexIndex; i++) {
    winObj.ch[0] = 3*(i+1);
    winObj.accX[i] = decode(win, obj, sampling);
    winObj.accY[i] = decode(win, obj, sampling);
    winObj.accZ[i] = decode(win, obj, sampling);
  }
  return winObj;
}

function decode(win, obj, sampling) {
  var acc = new Array(sampling);
  obj.hexIndex += 2;
  var hex_str1 = byte2Hex(win[obj.hexIndex++]);
  var hex_str2 = byte2Hex(win[obj.hexIndex++]);
  var smpl_size = parseInt(hex_str1.substr(0, 1), 16);
  var smpl_rate = (parseInt(hex_str1.substr(1, 1), 16) * 256) + (parseInt(hex_str2, 16));
  var sample_init = (win[obj.hexIndex++] & 0xff) << 24 | (win[obj.hexIndex++] & 0xff) << 16 | (win[obj.hexIndex++] & 0xff) << 8 | win[obj.hexIndex++] & 0xff;
  sample_init = sample_init / SHIFT_GAL;
  acc[0] = sample_init;
  var hold = sample_init;

  if (smpl_size == 0) {//追加1
    for (let i = 0; i < (sampling - 1); i++) {
      var sht;
      var thex_str1 = byte2Hex(win[obj.hexIndex]);//ab
      if (i % 2 == 0) {//偶数
        sht = (parseInt(thex_str1.substr(0, 1), 16));//a:0-15
      } else {//奇数
        sht = (parseInt(thex_str1.substr(1, 1), 16));//b:0-15
        obj.hexIndex++;
      }
      if (sht > 7) sht = sht - 16; //-8～7
      var tv = hold + sht / SHIFT_GAL;
      acc[i + 1] = tv;
      hold = tv;
    }
  } else if (smpl_size == 1) {
    for (i = 0; i < (sampling - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str2, 16));
      if (sht > (Math.pow(2, 7) - 1)) sht = sht - Math.pow(2, 8);
      var tv = hold + sht / SHIFT_GAL;
      acc[i + 1] = tv;
      hold = tv;
    }
  } else if (smpl_size == 2) {
    for (i = 0; i < (sampling - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var thex_str2 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str1, 16) * Math.pow(2, 8)) + (parseInt(thex_str2, 16));
      if (sht > (Math.pow(2, 15) - 1)) sht = sht - Math.pow(2, 16);
      var tv = hold + sht / SHIFT_GAL;
      acc[i + 1] = tv;
      hold = tv;
    }
  } else if (smpl_size == 3) {
    for (var i = 0; i < (smpl_rate - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var thex_str2 = byte2Hex(win[obj.hexIndex++]);
      var thex_str3 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str1, 16) * Math.pow(2, 16)) + (parseInt(thex_str2, 16) * Math.pow(2, 8)) + (parseInt(thex_str3, 16));
      if (sht > (Math.pow(2, 23) - 1)) sht = sht - Math.pow(2, 24);
      var tv = hold + sht / SHIFT_GAL;
      acc[i + 1] = tv;
      hold = tv;
    }
  } else if (smpl_size == 4) {
    for (var i = 0; i < (smpl_rate - 1); i++) {
      var thex_str1 = byte2Hex(win[obj.hexIndex++]);
      var thex_str2 = byte2Hex(win[obj.hexIndex++]);
      var thex_str3 = byte2Hex(win[obj.hexIndex++]);
      var thex_str4 = byte2Hex(win[obj.hexIndex++]);
      var sht = (parseInt(thex_str1, 16) * Math.pow(2, 24)) + (parseInt(thex_str2, 16) * Math.pow(2, 16)) + (parseInt(thex_str3, 16) * Math.pow(2, 8)) + (parseInt(thex_str4, 16));
      if (sht > (Math.pow(2, 31) - 1)) sht = sht - Math.pow(2, 32);
      var tv = hold + sht / SHIFT_GAL;
      acc[i + 1] = tv;
      hold = tv;
    }
  }
  return acc;
}

// utils
function hexString2Bytes(hex_str) {
  var result = [];
  for (var i = 0; i < hex_str.length; i += 2) {
    result.push(hex2Byte(hex_str.substr(i, 2)));
  }
  return result;
}

function hex2Byte(hex_str) {
  return parseInt(hex_str, 16);
}

function byte2Hex(byte_num) {
  var digits = (byte_num)?.toString(16) || '';//型エラー
  if (byte_num < 16) return '0' + digits;
  return digits;
}

function string2Utf8Bytes(text) {
  var result = [];
  if (text == null)
    return result;
  for (var i = 0; i < text.length; i++) {
    var c = text.charCodeAt(i);
    if (c <= 0x7f) {
      result.push(c);
    } else if (c <= 0x07ff) {
      result.push(((c >> 6) & 0x1F) | 0xC0);
      result.push((c & 0x3F) | 0x80);
    } else {
      result.push(((c >> 12) & 0x0F) | 0xE0);
      result.push(((c >> 6) & 0x3F) | 0x80);
      result.push((c & 0x3F) | 0x80);
    }
  }
  return result;
}
